import { getLocalStorage } from '../../_common/client/local-storage';
import { cmp } from '@otto-ec/eprivacy-cmp';

export const BOUNCE_GATE_LAST_OPENED_KEY = 'pdp_bounce-gate__last-opened-at';
export async function shouldShowBounceGate(event: MouseEvent): Promise<boolean> {
    const shouldOpen =
        didMouseLeaveOnTopBorder(event) &&
        (await isCookieBannerPermissionGranted()) &&
        !wasOpenedWithinLast30Minutes() &&
        isRecoAlternativeCinemaPresent();
    if (shouldOpen) {
        getLocalStorage().setItem(BOUNCE_GATE_LAST_OPENED_KEY, Math.floor(Date.now() / 1000 / 60).toString());
    }
    return shouldOpen;
}

function didMouseLeaveOnTopBorder(event: MouseEvent) {
    return event.clientY <= 1;
}

function wasOpenedWithinLast30Minutes() {
    const lastOpened = getLocalStorage().getItem(BOUNCE_GATE_LAST_OPENED_KEY);
    if (lastOpened === null) {
        return false;
    }
    const currentMinutes = Date.now() / 1000 / 60;
    return currentMinutes - +lastOpened < 30;
}

async function isCookieBannerPermissionGranted() {
    return cmp.getOttoOwnPurposesConsent();
}

function isRecoAlternativeCinemaPresent() {
    return document.querySelectorAll('.js_pdp_reco-alternative').length > 0;
}
